module.exports = __webpack_public_path__ + "img/logo.64efce0c.png";